import ClientOAuth2 from 'client-oauth2';
import { reducer as visualStackReducer } from '@cjdev/visual-stack-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { makeMiddleware } from './transducer';
import * as Nav from './navigation';
import * as Approvals from './approvals';
import * as Abilities from './abilities';
import * as Deployments from './deployments';
import * as User from './user';
import * as R from 'ramda';

const features = {
  "AUTOLOGIN": process.env.REACT_APP_AUTOLOGIN
};

const apiUrl = "https://juo1qh03n6.execute-api.us-east-1.amazonaws.com/version2";
const deploymentsApiUrl = "https://operations.api.cj.com/v1"
const oauth = (() => {
  const conf = {
    authorizationUri: 'https://login.cj.com/auth',
    accessTokenUri: 'https://production-iam.p.cjpowered.com/token'
  };
  switch (process.env.NODE_ENV) {
    case "development":
      return new ClientOAuth2({...conf,
        clientId: '4p6rfxf6ar7b3s3adpge9x5h1b',
        redirectUri: 'http://localhost:3000'
      });
    case "production":
      const productionClientId = "k6y92mdhc975c3ht6xvz88wp";
      return new ClientOAuth2({...conf,
            clientId: productionClientId,
            redirectUri: 'https://operations.cj.com'
          });
      default: return undefined;
  }
})();

const makeReduce = (...updates) => (state = {}, event) => {
  const combine = (s, upd) =>
    typeof upd === "function"
      ? upd(s, event)
      : {...s, [upd.key]: upd.update(s[upd.key], event)};
  return R.reduce(combine, state, updates);
};

const reduce = makeReduce(
  {key:"visualStack", update: visualStackReducer},
    Nav.update,
    Approvals.update,
    Abilities.update,
    Deployments.update,
    User.update);

const config = {oauth, apiUrl};
const middleware = applyMiddleware(
  makeMiddleware(Nav.transduce),
  makeMiddleware(Approvals.makeTransduce(config)),
  makeMiddleware(Abilities.makeTransduce(config)),
  makeMiddleware(User.makeTransduce(config)),
  makeMiddleware(Deployments.makeTransduce({apiUrl: deploymentsApiUrl}))
);
// this gets us the browser tools integration
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reduce, composeEnhancers(middleware));

Nav.init(store, features);
Approvals.init(store, features);
Abilities.init(store, features);
User.init(store, features);

export {store}



// WEBPACK FOOTER //
// ./src/wiring.js